import { addToast } from "@heroui/react";
import {
  AppToastVariant,
  getToastPlacementFromAnchorOrigin,
  mapSeverityToHeroTone,
  mapVariantToSeverity,
} from "src/components/UI/Alerts/toastTheme";

interface ShowToastProps {
  title: string;
  description?: string;
  variant?: AppToastVariant;
  duration?: number;
  hideCloseButton?: boolean;
  hideIcon?: boolean;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'start' | 'end';
  };
  icon?: any;
}

export const useToast = () => {
  const showToast = ({
    title,
    description,
    variant = "default",
    duration = 3000,
    hideCloseButton = false,
    hideIcon = false,
    anchorOrigin,
    icon,
  }: ShowToastProps) => {
    const severity = mapVariantToSeverity(variant);
    const toastPlacement = getToastPlacementFromAnchorOrigin(anchorOrigin);

    addToast({
      title,
      description,
      color: mapSeverityToHeroTone(severity),
      severity: mapSeverityToHeroTone(severity),
      radius: "lg",
      timeout: duration,
      hideCloseButton,
      hideIcon,
      shouldShowTimeoutProgress: true,
      ...(icon ? { icon } : {}),
      ...(toastPlacement ? { placement: toastPlacement } : {}),
    });
  };

  const showSuccessToast = (title: string, description?: string) => {
    showToast({ title, description, variant: "success" });
  };

  const showErrorToast = (title: string, description?: string) => {
    showToast({ title, description, variant: "danger" });
  };

  const showWarningToast = (title: string, description?: string) => {
    showToast({ title, description, variant: "warning" });
  };

  return {
    showToast,
    showSuccessToast,
    showErrorToast,
    showWarningToast,
  };
};
